import { CalculsFormCalendrierDepense } from '@norma/shared/constants/calculs';
import { IndemniteRepartieEchusIndirecte } from '@norma/shared/constants/calculs/type';
import { MonetaryErosion } from '@norma/shared/types/monetaryErosion.type';
import {
  PrejudiceFormCalendrierDepense,
  PrejudiceFormCalendrierDepenseCapitalisation,
} from '@norma/shared/types/prejudice.type';
import { Procedure } from '@norma/shared/types/procedure.type';
import { VictimeIndirecte } from '@norma/shared/types/victimeIndirecte.type';
import React from 'react';
import { Control } from 'react-hook-form';
import { ComputedPropsForm } from '../../forms/ComputedPropsForm';
import { TotalIndemniteGlobaleARepartirEchusIndirecte } from './TotalIndemniteGlobaleARepartirEchusIndirecte';

interface Props {
  control:
    | Control<PrejudiceFormCalendrierDepense>
    | Control<PrejudiceFormCalendrierDepenseCapitalisation>;
  tiersPayeurs: string[];
  monetaryErosions: MonetaryErosion[];
  dateLiquidation: Date | undefined;
  victimesIndirectes: VictimeIndirecte[];
  procedure: Procedure;
}

export const TotalDepensesEchuesIndirecte: React.FC<Props> = ({
  control,
  monetaryErosions,
  dateLiquidation,
  tiersPayeurs,
  victimesIndirectes,
  procedure,
}) => {
  return (
    <ComputedPropsForm
      control={control as Control<PrejudiceFormCalendrierDepense>}
      watchFields={[
        'rows',
        'revalorisationCoefficientsType',
        'partResponsabilite',
      ]}
      compute={([rows, revalorisationCoefficientsType, partResponsabilite]): {
        props: { indemniteRepartie: IndemniteRepartieEchusIndirecte };
      } => {
        const indemniteRepartie =
          CalculsFormCalendrierDepense.getIndemniteRepartieEchusIndirecte({
            rows,
            partResponsabilite:
              partResponsabilite || partResponsabilite === 0
                ? partResponsabilite / 100
                : procedure.partResponsabilite,
            tiersPayeurs,
            dateLiquidation,
            monetaryErosions,
            revalorisationCoefficientsType,
          });
        return {
          props: {
            indemniteRepartie,
          },
        };
      }}
      render={(props) => {
        const { indemniteRepartie } = props as {
          indemniteRepartie: IndemniteRepartieEchusIndirecte;
        };
        return (
          <TotalIndemniteGlobaleARepartirEchusIndirecte
            indemniteGlobaleARepartir={indemniteRepartie}
            victimesIndirectes={victimesIndirectes}
            partResponsabilite={procedure.partResponsabilite}
          />
        );
      }}
    />
  );
};
